import React from "react";
import "./education.css";
import { GiSchoolBag } from "react-icons/gi";
import { FaGraduationCap, FaSchool, FaUserGraduate } from "react-icons/fa";

function Education() {
  return (
    <div class="row section__content">
      <div class="col">
        <div class="main-timeline">
          <div class="timeline">
            <div className="flex justify-between items-center py-6 md:py-0">
              <div class="timeline-year p-4  text-xl lg:text-2xl xl:text-4xl  font-extrabold flex items-center justify-around w-full">
                <span className="px-2">2015-2019</span>
                <FaUserGraduate />
              </div>
              <div className="flex flex-col gap-2 w-full">
                <h3 class="title">Govt. Engineering College, Wayanad</h3>
                <div>
                  <p class="">Btech , Computer Science & Engineering</p>
                  <p class="">Secured 7.37 CGPA</p>
                </div>
              </div>
            </div>
          </div>
          <div class="timeline">
            <div className="flex flex-row-reverse justify-between items-center py-6 md:py-0">
              <div class="timeline-year p-4 flex-row-reverse text-xl lg:text-2xl xl:text-4xl  font-extrabold flex items-center justify-around w-full">
                <span className="px-2">2013-2015</span>
                <FaSchool />
              </div>
              <div className="flex flex-col gap-2 w-full">
                <h3 class="title">Mvhss Higher Secondary School</h3>
                <div>
                  <p class="">Higher Secondary Education</p>
                  <p class="">Secured 9.1 CGPA</p>
                </div>
              </div>
            </div>
          </div>
          <div class="timeline">
            <div className="flex justify-between items-center py-6 md:py-0">
              <div class="timeline-year p-4  text-xl lg:text-2xl xl:text-4xl  font-extrabold flex items-center justify-around w-full">
                <span className="px-2">2003-2013</span>
                <GiSchoolBag />
              </div>
              <div className="flex flex-col gap-2 w-full">
                <h3 class="title">UHHSS Higher Secondary school</h3>
                <div>
                  <p class="">Secondary Education</p>
                  <p class="">Secured 9.5 CGPA</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Education;
